/**
 * web/env.js — Web-only environment module.
 *
 * webpack replaces every import of `src/components/environment` with this
 * file at build time (via resolve.alias + NormalModuleReplacementPlugin in
 * webpack.config.js).  Android code keeps using the TypeScript environment
 * files — this module is invisible to Metro.
 *
 * Values are injected by dotenv-webpack from the selected .env.[profile]
 * file.  The DefinePlugin replaces `process.env.X` literals at compile time,
 * so no process.env object ships to the browser.
 */

export const environment = {
  /** Base URL for all API calls — matches apiUrl in the native env files. */
  apiUrl: process.env.API_URL || '',

  /** Semantic version shown in version-check API calls. */
  appVersion: process.env.APP_VERSION || '1.0.0',

  /** Set to "true" in .env.dev to log HTTP requests to the console. */
  enableApiDebugger: process.env.ENABLE_API_DEBUGGER === 'true',
};
